import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE } from '../config';
import { getStoredAuth } from '../api';
import Modal from './ui/Modal';

const styles = {
  subtitle: {
    color: '#B0BEC5',
    fontSize: '0.9rem',
    marginBottom: 24,
  },
  label: {
    display: 'block',
    color: '#B0BEC5',
    fontSize: '0.85rem',
    marginBottom: 6,
  },
  input: {
    width: '100%',
    boxSizing: 'border-box',
    padding: '12px 16px',
    marginBottom: 16,
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(0, 212, 255, 0.3)',
    borderRadius: 8,
    color: '#fff',
    fontSize: 16,
  },
  button: {
    width: '100%',
    padding: 14,
    marginTop: 8,
    background: 'linear-gradient(135deg, #B026FF 0%, #0066FF 100%)',
    border: '1px solid rgba(0, 212, 255, 0.5)',
    borderRadius: 8,
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
  },
  error: { color: '#ff6b6b', fontSize: 14, marginTop: 12 },
  skipLink: {
    display: 'block',
    textAlign: 'center',
    marginTop: 16,
    color: 'rgba(176, 190, 197, 0.8)',
    fontSize: 14,
    cursor: 'pointer',
    textDecoration: 'underline',
  },
};

export default function ChangePassword({ onSuccess, forceFirstAccess = false }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    onSuccess && onSuccess();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirmPassword) {
      setError('A nova senha e a confirmação não coincidem.');
      return;
    }
    if (newPassword.length < 6) {
      setError('A nova senha deve ter no mínimo 6 caracteres.');
      return;
    }
    setLoading(true);
    try {
      const auth = getStoredAuth();
      if (!auth?.token) {
        setError('Sessão expirada. Faça login novamente.');
        setLoading(false);
        return;
      }
      await axios.post(
        `${API_BASE}/api/auth/change-password`,
        { currentPassword, newPassword },
        { headers: { Authorization: `Bearer ${auth.token}` } }
      );
      onSuccess && onSuccess();
    } catch (err) {
      const msg = err.response?.data?.error || 'Erro ao alterar senha. Tente novamente.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open
      title="Trocar senha"
      onClose={!forceFirstAccess ? handleCancel : undefined}
      closeOnBackdrop={!forceFirstAccess}
    >
      <p style={styles.subtitle}>
        {forceFirstAccess
          ? 'Por segurança, defina uma nova senha antes de continuar. Use a senha temporária recebida por e-mail como "Senha atual".'
          : 'Altere sua senha de acesso ao dashboard.'}
      </p>
      <form onSubmit={handleSubmit}>
        <label style={styles.label}>{forceFirstAccess ? 'Senha temporária (recebida por e-mail)' : 'Senha atual'}</label>
        <input
          type="password"
          style={styles.input}
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          placeholder={forceFirstAccess ? 'Cole aqui a senha do e-mail' : 'Senha atual'}
          required
        />
        <label style={styles.label}>Nova senha</label>
        <input
          type="password"
          style={styles.input}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="Mínimo 6 caracteres"
          required
          minLength={6}
        />
        <label style={styles.label}>Confirmar nova senha</label>
        <input
          type="password"
          style={styles.input}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Repita a nova senha"
          required
        />
        {error && <p style={styles.error}>{error}</p>}
        <button type="submit" style={styles.button} disabled={loading}>
          {loading ? 'Salvando...' : 'Alterar senha'}
        </button>
      </form>
      {!forceFirstAccess && (
        <button type="button" style={styles.skipLink} onClick={handleCancel}>
          Cancelar / Voltar ao painel
        </button>
      )}
    </Modal>
  );
}
